import React from "react";
import { Typography, Divider, Space, Tag, Switch } from "antd";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { updateMfaInfo, loadRecord } from "../userDetailsSlice"; // Assuming this action exists

const { Title, Text } = Typography;

const TwoFactorAuth = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const activeUser = useSelector((state) => state.userDetails.activeUser);
  const { mfa_info } = activeUser;
  const { totp_enabled, phone_number } = mfa_info || {};

  // Handler for TOTP switch
  const handleTotpChange = async (checked) => {
    await dispatch(
      updateMfaInfo({ totp_enabled: checked, phone_number: activeUser.mfa_info.phone_number, id: activeUser.id })
    );
    dispatch(loadRecord(activeUser.id));
  };

  // Handler for Phone Number switch
  const handlePhoneChange = async (checked) => {
    await dispatch(
      updateMfaInfo({
        phone_number: checked === true ? activeUser.phone_number : null,
        totp_enabled: activeUser.mfa_info.totp_enabled,
        id: activeUser.id,
      })
    );
    dispatch(loadRecord(activeUser.id));
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <Divider />
        <Space direction="vertical" style={{ width: "100%" }}>
          <Title level={5} style={{ margin: 0 }}>
            {intl.formatMessage({
              id: "app.twoFactor.twoFactorTitle",
            })}
          </Title>
          {/* <Text>
            {intl.formatMessage({
              id: "app.twoFactor.twoFactorSubTitle",
            })}
          </Text> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Space size="large">
              <Space size="middle">
                <Text>
                  {intl.formatMessage({
                    id: "app.twoFactor.totpTitle",
                  })}
                </Text>
                <Switch
                  checked={totp_enabled}
                  disabled={!totp_enabled}
                  onChange={handleTotpChange}
                  style={{ marginLeft: 8 }}
                />
              </Space>
              <Space size="middle">
                <Text>
                  {intl.formatMessage({
                    id: "app.twoFactor.phoneTitle",
                  })}
                </Text>
                <Switch
                  checked={!!phone_number}
                  onChange={handlePhoneChange}
                  style={{ marginLeft: 8 }}
                />
              </Space>
            </Space>
          </div>
        </Space>
      </div>
    </>
  );
};

export default TwoFactorAuth;
